export default __webpack_public_path__ + "static/media/react.52610ecf.png";